import ElementContent from '@/components/sections/builder/elements/body/product-grid/content';
import ElementSetting from '@/components/sections/builder/elements/body/product-grid/setting';
import { ProductListElementDataType } from '@/components/sections/builder/elements/body/product-grid/type';
import { BetweenHorizontalStart } from 'lucide-react';

const defaultData: ProductListElementDataType = {
  name: 'Product Grid',
  contentAlign: 'left',
  headingLabel: 'Featured products',
  headingSize: 'small',
  textLabel: '',
  textStyle: 'body',
  limit: 4,
  totalCol: 4,
  totalColMobile: 1,
  size: 'small',
  showImage: true,
  showCategory: true,
  showShadow: false,
  rounded: 0,
  imageRatio: 'square',
  viewAllStyle: 'default',
  labelViewAll: 'View all',
  positionViewAll: 'bottom',
  padding: {
    top: 20,
    bottom: 20,
    left: 20,
    right: 20,
  },
};

export const ElementPreviewIcon = BetweenHorizontalStart;

const ProductList = {
  type: 'product_list',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
};

export default ProductList;
